export default __webpack_public_path__ + "static/media/info.d396b2c4.png";